export const replaceDynamicText = (htmltext, replacement) => {
  const parsedText = Object.keys(replacement).reduce((p, c) => p.replace(`{{${c}}}`, replacement[c]), htmltext);

  return parsedText;
};

export const findDynamicText = (htmltext) => {
  const regexp = /{{\w+}}/g;
  const words = [...htmltext.matchAll(regexp)];
  return words.map((e) => e[0].replaceAll('{', '').replaceAll('}', ''));
};
